import React, { useState } from 'react';

export interface OptionProps {
  option: any;
  objectKey: string;
  onSelect: Function;
}

const DropdownOption = ({ option, objectKey, onSelect }: OptionProps) => {
  const [isHovering, setIsHovering] = useState(false);
  return (
    <div
      style={{
        padding: '0.5rem',
        backgroundColor: isHovering ? '#d3d3d3' : 'white',
        fontSize: '12px'
      }}
      onClick={() => onSelect(option)}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {option[objectKey]}
    </div>
  );
};

export default DropdownOption;
